import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './UpgradePlanCards.module.css';
import checkmark from '../../../assets/plans/checkmark.svg';
import checkmarkButton from '../../../assets/plans/check-nobold.svg';
import { currencyFormat } from '../../../util';
import { DeductibleReimbursement } from '../customPlan/DeductibleReimbursement';

export const UpgradePlanCard = ({
  coveredItems = [],
  description = '',
  icon = null,
  id = '',
  isSelected = false,
  monthly = false,
  onClick = () => { },
  plans = [],
  price = 0,
  quoteSelected = null,
  title = '',
}) => {
  const { t } = useTranslation('quoting');

  return (
    <div
      className={styles.container}
      data-selected={isSelected}
      id={id}
    >
      <div className={styles.header}>
        <div className={styles.titleData}>
          <h2>{title}</h2>

          <p>{description}</p>
        </div>

        <img alt="" className={styles.planImg} src={icon} />
      </div>

      <hr className={styles.headerSeparator} />

      <div className={styles.covered}>
        <h3>{t('prop103.whatsCovered')}</h3>

        <ul className={styles.coveredList}>
          {coveredItems.map((cover) => (
            <li key={cover}>
              <img alt="" src={checkmark} />

              {cover}
            </li>
          ))}
        </ul>
      </div>

      <div className={styles.mobileSelectors}>
        <DeductibleReimbursement
          plans={plans}
          quoteSelected={quoteSelected}
        />
      </div>

      <hr className={styles.priceSeparator} />

      <div className={styles.priceContainer}>
        <span>
          {t(`prop103.${monthly ? 'monthlyPrice' : 'yearlyPrice'}`, {
            price: currencyFormat({ fixed: 2, value: price }),
          })}
        </span>

        <button
          className={styles.selectButton}
          data-selected={isSelected}
          onClick={onClick}
          type="button"
        >
          {isSelected
            ? (
              <>
                <img alt="" src={checkmarkButton} />

                <span>{t('prop103.selected')}</span>
              </>
            ) : t('prop103.select', { name: title })}
        </button>
      </div>
    </div>
  );
};
